import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { IScrapRow, useScrapTableData } from "./hooks/useScrapTableData";
import { EditScrapModal } from "./modals/EditScrapModal";

interface Props {
	refreshData: Function;
}

export const ScrapTable = ({ refreshData }: Props) => {
	const classes = useTableStyles();
	const { state, actions } = useCastersContext();
	const processData = state.processData;
	const scrapReasons = state.scrapReasons || [];

	const [showEditModal, setShowEditModal] = useState<boolean>(false);
	const [scrapSelected, setScrapSelected] = useState<IScrapRow | null>(null);

	const handleEditButtonClick = (scrap: IScrapRow) => {
		setScrapSelected(scrap);
		setShowEditModal(true);
		actions.setRefreshInPause(true);
	};

	const { columns, rowData, statusBar } = useScrapTableData({
		processData,
		scrapReasons,
		editCallback: handleEditButtonClick,
	});

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "11.6rem" }}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.id}
							suppressContextMenu
							statusBar={statusBar}
						/>
					</div>
				</Box>
			</Paper>

			{showEditModal && (
				<EditScrapModal
					show={showEditModal}
					onHide={(shouldUpdate) => {
						setShowEditModal(false);
						if (shouldUpdate) {
							refreshData();
							actions.setRefreshInPause(false);
						}
					}}
					scrap={scrapSelected}
				/>
			)}
		</>
	);
};
